import React from 'react'

import { FadeInOut } from '@pb/components'

const PurchaseDetails: React.FC<any> = ({ children, isExpanded }) => (
  <FadeInOut isVisible={isExpanded}>{children}</FadeInOut>
)

export default PurchaseDetails
